import { render, staticRenderFns } from "./SellProductsFromStock.vue?vue&type=template&id=60283fad&scoped=true"
import script from "./SellProductsFromStock.vue?vue&type=script&lang=js"
export * from "./SellProductsFromStock.vue?vue&type=script&lang=js"
import style0 from "./SellProductsFromStock.vue?vue&type=style&index=0&id=60283fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60283fad",
  null
  
)

export default component.exports